import FreestarAdSlot from '@freestar/pubfig-adslot-react-component'
import { AdUnitPlaceholder, AdUnitPlaceholderProps } from '@news12/storybook-news'

import React, { memo, useEffect, useState } from 'react'

import useRegion from '../../hooks/useRegion'
import adConfig, { Tag, TAdConfigType } from '../../utils/ads/adConfig'
import mapAdUnitName from '../../utils/ads/freestarAdMap'
import SafeFreestarWrapper from './SafeFreestarWrapper'

export type AdUnitProps = {
  id: string
  tags?: Tag[]
  contentfulCategories?: string[]
  type: TAdConfigType
  adUnitTemplate?: AdUnitPlaceholderProps['template']
  adUnitSizes?: AdUnitPlaceholderProps['sizes']
  uniqueIdentifier?: string
}

const AdUnit = memo(
  ({ id, type, adUnitTemplate, adUnitSizes, tags, contentfulCategories, uniqueIdentifier }: AdUnitProps) => {
    const { shortName, isReadyOnClientSide } = useRegion()
    const [regionShortName, setRegionShortName] = useState<string>(shortName || '')
    useEffect(() => {
      if (isReadyOnClientSide) {
        setRegionShortName(shortName || '')
      }
    }, [regionShortName, isReadyOnClientSide])

    const freestarConfig = adConfig(type, 'default', tags, contentfulCategories, id)
    const mappedUnitName = `news12_${mapAdUnitName(id)}`
    const slotID = uniqueIdentifier ? `${mappedUnitName}_${uniqueIdentifier}` : mappedUnitName

    return (
      <AdUnitPlaceholder template={adUnitTemplate} sizes={adUnitSizes}>
        {regionShortName && (
          <SafeFreestarWrapper source='components/Ads/AdUnit.tsx'>
            <FreestarAdSlot
              publisher={'news12-com'}
              placementName={mappedUnitName}
              channel={regionShortName.toUpperCase()}
              targeting={freestarConfig.targeting}
              slotId={slotID}
            />
          </SafeFreestarWrapper>
        )}
      </AdUnitPlaceholder>
    )
  }
)

export default AdUnit
